import React, { useEffect, useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";
import EessAutocomplete from "../../../components/autocomplete/EessAutocomplete";
// Importamos el componente reutilizable (ajusta la ruta si varía en tu proyecto)
import DrawerFilter from "../../../components/listing/DrawerFilter";

export default function FiltroBonificacion({
  initialFilters = {},
  onSubmit = () => {},
  onClose = () => {},
}) {
  // --- ESTADOS DE FILTROS ---
  const [nombre, setNombre] = useState(initialFilters.nombre || "");
  const [rubroId, setRubroId] = useState(initialFilters.rubroId || "");
  
  // Para EESS usamos un estado de objeto para el Autocomplete
  const [selectedEess, setSelectedEess] = useState(null);

  // --- CATALOGOS ---
  const [rubros, setRubros] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Cargar Rubros al montar
  useEffect(() => {
    const cargarCatalogos = async () => {
      try {
        const resRub = await appFetchJson(apiRoutes.rubros.listUrl({ page: 0, size: 200 }));
        setRubros(resRub?.items || []);
      } catch (e) {
        console.error("Error cargando filtros:", e);
      }
    };
    cargarCatalogos();
  }, []);

  // --- SUBMIT ---
  const handleApply = () => {
    setIsLoading(true);
    
    onSubmit({
      nombre: nombre.trim(),
      rubroId: rubroId || null,
      // Extraemos el ID del objeto seleccionado en el autocomplete
      eessId: selectedEess ? selectedEess.id : null,
    });
    
    setIsLoading(false);
    onClose();
  };

  return (
    <DrawerFilter
      title="Filtros de Bonificación"
      onClose={onClose}
      onApply={handleApply}
      isLoading={isLoading}
    >
      {/* 1. CAMPO DESCRIPCIÓN / NOMBRE */}
      <div>
        <label className="form-label-fil">Descripción:</label>
        <input 
          type="text" 
          className="input mt-1 w-full" 
          value={nombre} 
          onChange={(e) => setNombre(e.target.value)} 
          placeholder="Ej: Bonificación Autogas..."
        />
      </div>

      {/* 2. COMBO RUBRO */}
      <div>
        <label className="form-label-fil">Rubro:</label>
        <select 
          className="input mt-1 w-full" 
          value={rubroId} 
          onChange={(e) => setRubroId(e.target.value)}
        >
          <option value="">-- Todos --</option>
          {rubros.map(opt => (
            <option key={opt.id} value={opt.id}>{opt.nombre}</option>
          ))}
        </select>
      </div>

      {/* 3. AUTOCOMPLETE EE.SS. */}
      <div>
        <label className="form-label-fil">Estación (EE.SS.):</label>
        <div className="w-full mt-1">
          <EessAutocomplete
            value={selectedEess}
            onChange={setSelectedEess}
            placeholder="Buscar Estación..."
          />
        </div>
      </div>

    </DrawerFilter>
  );
}